import React, { createContext, useState, useEffect, useContext } from 'react';
import api from '../api/axios'; // Importa tu instancia de axios configurada
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null); // { id, numeroApartamento, isAdmin }
  const [isAdmin, setAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  const [mustChangedPassword, setmustChanged] = useState(false)
  const navigate = useNavigate();

  // Función para cargar el usuario desde localStorage al iniciar la app
  useEffect(() => {
    const loadUserFromStorage = () => {
      const token = localStorage.getItem('token');
      const userId = localStorage.getItem('userId');
      const numeroApartamento = localStorage.getItem('numeroApartamento');
      const isAdmin = localStorage.getItem('isAdmin') === 'true'; // Convertir a booleano

      if (token && userId && numeroApartamento) {
        setIsAuthenticated(true);
        setAdmin(isAdmin); // ✅ acá faltaba
        setUser({ id: userId, numeroApartamento, isAdmin });
      } else {
        setIsAuthenticated(false);
        setAdmin(false); // ✅ acá faltaba
        setUser(null);
      }
      setLoading(false);
    };

    loadUserFromStorage();
  }, []);

 const login = async (numeroApartamento, password) => {
  try {
    const response = await api.post('/Auth/login', { numeroApartamento, password });
    const { isAuthSuccessful, token, userId, numeroApartamento: aptNum, isAdmin, mustChangePassword } = response.data;

    if (isAuthSuccessful) {
      localStorage.setItem('token', token);
      localStorage.setItem('userId', userId);
      localStorage.setItem('numeroApartamento', aptNum);
      localStorage.setItem('isAdmin', isAdmin);

      setIsAuthenticated(true);
      setAdmin(isAdmin);
      setUser({ id: userId, numeroApartamento: aptNum, isAdmin });
      setmustChanged(mustChangePassword);

      // 👇 ❌ No navegamos desde acá
      return { success: true, mustChangePassword, isAdmin };
    }

    // ⚠️ Devuelve mensaje de error del backend o por defecto
    return {
      success: false,
      message: response.data.errorMessage || 'Credenciales inválidas.',
    };

  } catch (error) {
    console.error('Error de login:', error);
    const msg =
      error.response?.data?.errorMessage ||
      error.response?.data?.message ||
      'Error al conectar con el servidor.';
    return { success: false, message: msg };
  }
};


  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    localStorage.removeItem('numeroApartamento');
    setIsAuthenticated(false);
    setUser(null);
    setAdmin(false)
    navigate('/login'); // Redirige a la página de login al cerrar sesión
  };

  const changePassword = async (currentPassword, newPassword, confirmNewPassword) => {
    try {
      const response = await api.post('/Auth/change-password', { currentPassword, newPassword, confirmNewPassword });
      return { success: response.data.isAuthSuccessful, message: response.data.errorMessage };
    } catch (error) {
      console.error('Error al cambiar contraseña:', error);
      return { success: false, message: error.response?.data?.errorMessage || 'Error al cambiar contraseña.' };
    }
  };

  const adminResetPassword = async (userIdToReset, newPassword) => {
    try {
      const response = await api.post('/Auth/admin-reset-password', { numeroApartamento: userIdToReset, newPassword });
      return { success: response.data.isAuthSuccessful, message: response.data.errorMessage };
    } catch (error) {
      console.error('Error al resetear contraseña por admin:', error);
      return { success: false, message: error.response?.data || 'Error al resetear contraseña.' };
    }
  }

  const value = {
    isAuthenticated,
    isAdmin,
    user,
    loading,
    login,
    logout,
    changePassword,
    adminResetPassword,
    loading,
    mustChangedPassword
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);